import React, { useContext, useEffect } from "react";
import BaseModal from "../../components/BaseModal";
import { useTranslation } from "react-i18next";
import { MODAL_TYPES } from "../../utils/emitter";
import "./style.scss";
import ROUTES from "../../utils/routes";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import useModalActions from "../../hooks/useModalActions";
import BaseButton from "../../components/BaseButton";
import BaseIcon from "../../components/BaseIcon";
import PersonalAccount from "../../store/PersonalAccount";

export default function AddMainScreenModal() {
  const { t } = useTranslation();
  const { navigateTo } = useCustomNavigate();
  const { closeModal } = useModalActions();

  return (
    <BaseModal
      descriptionStyle="add_main_screen__desc"
      eventTypeModal={MODAL_TYPES.ADD_MAIN_SCREEN}
      description={t("modals.add_main_screen.text")}
    >
      <BaseButton
        className="add_main_screen__button"
        onClick={() => {
          closeModal(MODAL_TYPES.ADD_MAIN_SCREEN);
          navigateTo(ROUTES.PWA_INSTRUCTIONS_PAGE);
        }}
      >
        <BaseIcon
          name={"main_screen_light"}
          className="add_main_screen__icon"
        />
        {t("modals.add_main_screen.button")}
      </BaseButton>
    </BaseModal>
  );
}
